import styled from 'styled-components';
import { NavBar as PantheonNav, TABLET } from '@minerva-analytics/pantheon';
import { RED, WHITE } from '../../theme';

const NavBar = styled(PantheonNav)`
  border-top: 1rem solid ${RED};
  z-index: 1;
  img {
    width: auto;
    height: 75px;
    @media (max-width: ${TABLET}) {
      height: 60px;
      margin-top: 0;
      padding-bottom: 15px;
    }
    margin-top: 20px;
  }

  a {
    text-transform: uppercase;
    font-size: 22px;
    font-family: 'Avenir Next Condensed', sans-serif;
    letter-spacing: 0.55px;
    z-index: 1;
    @media (max-width: ${TABLET}) {
      color: ${WHITE};
    }
  }

  button {
    @media (max-width: ${TABLET}) {
      display: none;
    }
  }
`;


export { NavBar };